import { render, staticRenderFns } from "./RenameWebsiteDialog.vue?vue&type=template&id=18ab31ac&"
import script from "./RenameWebsiteDialog.vue?vue&type=script&lang=ts&"
export * from "./RenameWebsiteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports